module.exports = __webpack_public_path__ + "img/layout-sidebar-inset.5593df71.svg";